export function category_key(name: string | undefined | null): string {
    if (!name) return ''
    return Array.from(name.toLowerCase().normalize('NFD'))
        .filter((c) => {
            const code = c.charCodeAt(0)
            return code < 0x0300 || code > 0x036f
        })
        .join('')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, '_')
        .replace(/^_|_$/g, '')
}
